var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "新規追加", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("UserMasterForm", {
              ref: "userForm",
              attrs: {
                "label-width": "10em",
                formMode: "register",
                "autocomplete-user-id-set": _vm.autocompleteUserIdSet,
                "autocomplete-user-name-set": _vm.autocompleteUserNameSet
              },
              model: {
                value: _vm.userFormModel,
                callback: function($$v) {
                  _vm.userFormModel = $$v
                },
                expression: "userFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("RegisterDialogFooter", {
              on: { clear: _vm.clickClear, register: _vm.clickRegister }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }